import React from 'react'
import styled from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import colors from 'theme/colors';
import Text from './Text';

export default function Radio({
    selected = true,
    label,
    description,
    icon: Icon,
    accentColor = colors.primary,
    textSize,
    style,
    marginTop,
    textStyle = {},
    onSelect = () => false
}) {
    return (
        <Container
            paddingBottom='10px'
            marginTop={marginTop}
            hasDescription={!!description}
            onClick={() => onSelect()}
        >
            <StyledRadio selected={selected} accentColor={accentColor} hasDescription={!!description}>
                <StyledRadioSelect selected={selected} accentColor={accentColor} />
            </StyledRadio>

            {Icon && (
                <IconWrap selected={selected} accentColor={accentColor} hasDescription={!!description}>
                    <Icon size={15} strokeWidth={2} />
                </IconWrap>
            )}

            <Texts>
                <Text
                    color={selected ? accentColor : colors.night}
                    style={textStyle}
                >
                    {label}
                </Text>

                {description && (
                    <Text name='mini' color={colors.nightLight} paddingBottom={0} marginTop='2px'>
                        {description}
                    </Text>
                )}
            </Texts>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: ${({ hasDescription }) => hasDescription ? 'flex-start' : 'center'};
    margin-top: 20px;
    cursor: pointer;

    ${({ marginTop }) => marginTop && `
        margin-top: ${marginTop} !important;
    `};
`;

const Texts = styled.div`
    display: flex;
    flex-direction: column;
`;

const StyledRadio = styled(FullyCentered)`
    flex-shrink: 0;
    border: 1px solid ${colors.night};
    padding: 2px;
    border-radius: 30px;
    width: 16px;
    height: 16px;
    margin-right: 10px;

    ${({ hasDescription }) => hasDescription && `
        margin-top: 2px;
    `};

    ${({ selected, accentColor }) => selected && `
        border: 1px solid ${accentColor};
    `};
`;

const StyledRadioSelect = styled.div`
    display: none;
    background: ${({ accentColor }) => accentColor};
    width: 10px;
    height: 10px;
    border-radius: 30px;

    ${({ selected }) => selected && `
        display: flex;
    `};
`;

const IconWrap = styled.span`
    display: inline-flex;
    flex-shrink: 0;
    margin-right: 8px;
    color: ${({ selected, accentColor }) => selected ? accentColor : colors.night};

    ${({ hasDescription }) => hasDescription && `
        margin-top: 1px;
    `};
`;
